$(document).ready(function () {
  document
    .querySelectorAll(
      "#report_user_start_day_hidden, #report_user_end_day_hidden, #group_report_start_day_hidden,#group_report_end_day_hidden",
    )
    .forEach(function (elem) {
      if (elem.id) {
        let select_date = new Date()
        if (!!elem.value) {
          let converted = moment(elem.value, rails_variables.current_org_date_format).format("MM/DD/YYYY")
          select_date = new Date(converted)
        }
        let datepicker = MCDatepicker.create({
          el: "#" + elem.id,
          dateFormat: rails_variables.current_org_date_format,
          selectedDate: select_date,
          customCancelBTN: "Close",
        })
        datepicker.onSelect(function (date, formatedDate) {
          $(elem).next().val(date)
          elem.value = formatedDate
          elem.dispatchEvent(new Event("change"))
        })
      }
    })

  $("#this_week_new_hires").on("change", function () {
    this.value = this.checked ? "1" : "0"
  })

  $("#select_all_user").on("click", function () {
    if (this.checked == false) {
      $("#course-users input:checkbox:checked").each(function () {
        this.checked = false
      })
    } else {
      $("#course-users input:visible:checkbox:not(:checked)").each(function () {
        this.checked = true
      })
    }
    if ($("#course-users input:checkbox:checked").length > 0) {
      if ($("#custom-report-step3").length == 1) {
        $("#custom-report-step3").css("display", "none")
        $("#custom-report-step4").css("display", "none")
      }
      $(".generate-btns").children().css("opacity", "1")
      $(".generate-btns").children().css("pointer-events", "all")
    } else {
      if ($("#custom-report-step3").length == 1) {
        $("#custom-report-step3").css("display", "none")
        $("#custom-report-step4").css("display", "none")
      }
      $(".generate-btns").children().css("opacity", ".2")
      $(".generate-btns").children().css("pointer-events", "none")
    }
  })

  $("#select_all_groups").on("click", function () {
    if (this.checked == false) {
      $("#course-users input:checkbox:checked").each(function () {
        this.checked = false
      })
    } else {
      $("#course-users input:visible:checkbox:not(:checked)").each(function () {
        this.checked = true
      })
    }
    if ($("#course-users input:checkbox:checked").length > 0) {
      if ($("#custom-report-step3").length == 1) {
        $("#custom-report-step3").css("display", "none")
        $("#custom-report-step4").css("display", "none")
      }
      $(".generate-btns").children().css("opacity", "1")
      $(".generate-btns").children().css("pointer-events", "all")
    } else {
      if ($("#custom-report-step3").length == 1) {
        $("#custom-report-step3").css("display", "none")
        $("#custom-report-step4").css("display", "none")
      }
      $(".generate-btns").children().css("opacity", ".2")
      $(".generate-btns").children().css("pointer-events", "none")
    }
  })
})
